module.exports = __webpack_public_path__ + "img/andara.b850d06e.png";